export const DANGER = {
  DARKER: '#8c0005',
  DARK: '#b8000e',
  DEFAULT: '#dc1f30',
  LIGHT: '#ff8d85',
  LIGHTER: '#ffdad5',
  LIGHTEST: '#ffece9',
} as const;
